var map = {
	"./1-afraid.jpg": 58534,
	"./1-angry.jpg": 30652,
	"./1-happy.jpg": 26165,
	"./1-neutral.jpg": 70102,
	"./1-sad.jpg": 64891,
	"./10-afraid.jpg": 19012,
	"./10-angry.jpg": 38722,
	"./10-happy.jpg": 18327,
	"./10-neutral.jpg": 63952,
	"./10-sad.jpg": 70129,
	"./100-afraid.jpg": 17230,
	"./100-angry.jpg": 56516,
	"./100-happy.jpg": 36637,
	"./100-neutral.jpg": 69182,
	"./100-sad.jpg": 62083,
	"./101-afraid.jpg": 93257,
	"./101-angry.jpg": 75821,
	"./101-happy.jpg": 16208,
	"./101-neutral.jpg": 76607,
	"./101-sad.jpg": 9142,
	"./102-afraid.jpg": 22892,
	"./102-angry.jpg": 62858,
	"./102-happy.jpg": 69951,
	"./102-neutral.jpg": 95768,
	"./102-sad.jpg": 92377,
	"./103-afraid.jpg": 82511,
	"./103-angry.jpg": 12339,
	"./103-happy.jpg": 45514,
	"./103-neutral.jpg": 36769,
	"./103-sad.jpg": 75156,
	"./104-afraid.jpg": 52570,
	"./104-angry.jpg": 11832,
	"./104-happy.jpg": 38657,
	"./104-neutral.jpg": 89322,
	"./104-sad.jpg": 13919,
	"./105-afraid.jpg": 57525,
	"./105-angry.jpg": 75633,
	"./105-happy.jpg": 5508,
	"./105-neutral.jpg": 715,
	"./105-sad.jpg": 92306,
	"./106-afraid.jpg": 59048,
	"./106-angry.jpg": 62430,
	"./106-happy.jpg": 26995,
	"./106-neutral.jpg": 63092,
	"./106-sad.jpg": 565,
	"./107-afraid.jpg": 29259,
	"./107-angry.jpg": 43319,
	"./107-happy.jpg": 56878,
	"./107-neutral.jpg": 99005,
	"./107-sad.jpg": 25584,
	"./108-afraid.jpg": 83462,
	"./108-angry.jpg": 83388,
	"./108-happy.jpg": 78901,
	"./108-neutral.jpg": 57206,
	"./108-sad.jpg": 19579,
	"./109-afraid.jpg": 56417,
	"./109-angry.jpg": 17925,
	"./109-happy.jpg": 40616,
	"./109-neutral.jpg": 10423,
	"./109-sad.jpg": 76910,
	"./11-afraid.jpg": 95847,
	"./11-angry.jpg": 11819,
	"./11-happy.jpg": 81442,
	"./11-neutral.jpg": 55801,
	"./11-sad.jpg": 40332,
	"./110-afraid.jpg": 87327,
	"./110-angry.jpg": 66595,
	"./110-happy.jpg": 95354,
	"./110-neutral.jpg": 41873,
	"./110-sad.jpg": 44900,
	"./111-afraid.jpg": 91580,
	"./111-angry.jpg": 10106,
	"./111-happy.jpg": 41487,
	"./111-neutral.jpg": 74856,
	"./111-sad.jpg": 59113,
	"./112-afraid.jpg": 19481,
	"./112-angry.jpg": 99389,
	"./112-happy.jpg": 12960,
	"./112-neutral.jpg": 87727,
	"./112-sad.jpg": 67334,
	"./113-afraid.jpg": 15998,
	"./113-angry.jpg": 85492,
	"./113-happy.jpg": 59981,
	"./113-neutral.jpg": 7214,
	"./113-sad.jpg": 94451,
	"./114-afraid.jpg": 38299,
	"./114-angry.jpg": 20519,
	"./114-happy.jpg": 61022,
	"./114-neutral.jpg": 70029,
	"./114-sad.jpg": 35904,
	"./115-afraid.jpg": 36824,
	"./115-angry.jpg": 54894,
	"./115-happy.jpg": 43907,
	"./115-neutral.jpg": 17700,
	"./115-sad.jpg": 49477,
	"./116-afraid.jpg": 66437,
	"./116-angry.jpg": 11329,
	"./116-happy.jpg": 38452,
	"./116-neutral.jpg": 41371,
	"./116-sad.jpg": 51394,
	"./117-afraid.jpg": 69962,
	"./117-angry.jpg": 76808,
	"./117-happy.jpg": 83121,
	"./117-neutral.jpg": 35322,
	"./117-sad.jpg": 5167,
	"./118-afraid.jpg": 48407,
	"./118-angry.jpg": 26011,
	"./118-happy.jpg": 68882,
	"./118-neutral.jpg": 26729,
	"./118-sad.jpg": 54716,
	"./119-afraid.jpg": 76660,
	"./119-angry.jpg": 64914,
	"./119-happy.jpg": 14279,
	"./119-neutral.jpg": 39712,
	"./119-sad.jpg": 80577,
	"./12-afraid.jpg": 67846,
	"./12-angry.jpg": 1980,
	"./12-happy.jpg": 13845,
	"./12-neutral.jpg": 29334,
	"./12-sad.jpg": 93147,
	"./120-afraid.jpg": 37508,
	"./120-angry.jpg": 82978,
	"./120-happy.jpg": 16823,
	"./120-neutral.jpg": 6608,
	"./120-sad.jpg": 43249,
	"./121-afraid.jpg": 6663,
	"./121-angry.jpg": 61995,
	"./121-happy.jpg": 72482,
	"./121-neutral.jpg": 44217,
	"./121-sad.jpg": 51724,
	"./122-afraid.jpg": 16774,
	"./122-angry.jpg": 66236,
	"./122-happy.jpg": 10517,
	"./122-neutral.jpg": 66166,
	"./122-sad.jpg": 71259,
	"./123-afraid.jpg": 93697,
	"./123-angry.jpg": 66341,
	"./123-happy.jpg": 88424,
	"./123-neutral.jpg": 94903,
	"./123-sad.jpg": 5742,
	"./124-afraid.jpg": 33184,
	"./124-angry.jpg": 35542,
	"./124-happy.jpg": 72011,
	"./124-neutral.jpg": 67916,
	"./124-sad.jpg": 67981,
	"./125-afraid.jpg": 30179,
	"./125-angry.jpg": 99023,
	"./125-happy.jpg": 54310,
	"./125-neutral.jpg": 28149,
	"./125-sad.jpg": 2120,
	"./13-afraid.jpg": 40801,
	"./13-angry.jpg": 36517,
	"./13-happy.jpg": 59208,
	"./13-neutral.jpg": 82551,
	"./13-sad.jpg": 34126,
	"./14-afraid.jpg": 5568,
	"./14-angry.jpg": 92822,
	"./14-happy.jpg": 77707,
	"./14-neutral.jpg": 44780,
	"./14-sad.jpg": 5805,
	"./15-afraid.jpg": 37827,
	"./15-angry.jpg": 16911,
	"./15-happy.jpg": 53798,
	"./15-neutral.jpg": 72469,
	"./15-sad.jpg": 96872,
	"./16-afraid.jpg": 3378,
	"./16-angry.jpg": 11440,
	"./16-happy.jpg": 72185,
	"./16-neutral.jpg": 93058,
	"./16-sad.jpg": 1751,
	"./17-afraid.jpg": 51245,
	"./17-angry.jpg": 57129,
	"./17-happy.jpg": 18300,
	"./17-neutral.jpg": 7843,
	"./17-sad.jpg": 55754,
	"./18-afraid.jpg": 7276,
	"./18-angry.jpg": 81450,
	"./18-happy.jpg": 88543,
	"./18-neutral.jpg": 51544,
	"./18-sad.jpg": 49593,
	"./19-afraid.jpg": 66895,
	"./19-angry.jpg": 47283,
	"./19-happy.jpg": 64106,
	"./19-neutral.jpg": 92545,
	"./19-sad.jpg": 32372,
	"./2-afraid.jpg": 88327,
	"./2-angry.jpg": 20843,
	"./2-happy.jpg": 62178,
	"./2-neutral.jpg": 11033,
	"./2-sad.jpg": 69036,
	"./20-afraid.jpg": 90335,
	"./20-angry.jpg": 53923,
	"./20-happy.jpg": 42714,
	"./20-neutral.jpg": 47633,
	"./20-sad.jpg": 82628,
	"./21-afraid.jpg": 76988,
	"./21-angry.jpg": 79834,
	"./21-happy.jpg": 62415,
	"./21-neutral.jpg": 20648,
	"./21-sad.jpg": 78569,
	"./22-afraid.jpg": 51577,
	"./22-angry.jpg": 26813,
	"./22-happy.jpg": 53632,
	"./22-neutral.jpg": 99535,
	"./22-sad.jpg": 47302,
	"./23-afraid.jpg": 64222,
	"./23-angry.jpg": 96372,
	"./23-happy.jpg": 13037,
	"./23-neutral.jpg": 12878,
	"./23-sad.jpg": 13907,
	"./24-afraid.jpg": 89435,
	"./24-angry.jpg": 5991,
	"./24-happy.jpg": 44606,
	"./24-neutral.jpg": 84941,
	"./24-sad.jpg": 79072,
	"./25-afraid.jpg": 46776,
	"./25-angry.jpg": 35374,
	"./25-happy.jpg": 50883,
	"./25-neutral.jpg": 65796,
	"./25-sad.jpg": 62629,
	"./26-afraid.jpg": 21093,
	"./26-angry.jpg": 95201,
	"./26-happy.jpg": 23444,
	"./26-neutral.jpg": 12059,
	"./26-sad.jpg": 64546,
	"./27-afraid.jpg": 24842,
	"./27-angry.jpg": 6920,
	"./27-happy.jpg": 817,
	"./27-neutral.jpg": 89434,
	"./27-sad.jpg": 58351,
	"./28-afraid.jpg": 57751,
	"./28-angry.jpg": 90203,
	"./28-happy.jpg": 44722,
	"./28-neutral.jpg": 36329,
	"./28-sad.jpg": 47548,
	"./29-afraid.jpg": 5716,
	"./29-angry.jpg": 84530,
	"./29-happy.jpg": 81095,
	"./29-neutral.jpg": 74560,
	"./29-sad.jpg": 54593,
	"./3-afraid.jpg": 37444,
	"./3-angry.jpg": 23202,
	"./3-happy.jpg": 30423,
	"./3-neutral.jpg": 40368,
	"./3-sad.jpg": 67729,
	"./30-afraid.jpg": 98574,
	"./30-angry.jpg": 10756,
	"./30-happy.jpg": 87101,
	"./30-neutral.jpg": 25150,
	"./30-sad.jpg": 35491,
	"./31-afraid.jpg": 24425,
	"./31-angry.jpg": 37709,
	"./31-happy.jpg": 32016,
	"./31-neutral.jpg": 41215,
	"./31-sad.jpg": 46518,
	"./32-afraid.jpg": 18572,
	"./32-angry.jpg": 87562,
	"./32-happy.jpg": 23295,
	"./32-neutral.jpg": 89432,
	"./32-sad.jpg": 48153,
	"./33-afraid.jpg": 45583,
	"./33-angry.jpg": 88051,
	"./33-happy.jpg": 84202,
	"./33-neutral.jpg": 7297,
	"./33-sad.jpg": 66932,
	"./34-afraid.jpg": 44570,
	"./34-angry.jpg": 12472,
	"./34-happy.jpg": 45185,
	"./34-neutral.jpg": 33770,
	"./34-sad.jpg": 2271,
	"./35-afraid.jpg": 45429,
	"./35-angry.jpg": 70161,
	"./35-happy.jpg": 56836,
	"./35-neutral.jpg": 16203,
	"./35-sad.jpg": 89554,
	"./36-afraid.jpg": 65480,
	"./36-angry.jpg": 81150,
	"./36-happy.jpg": 30867,
	"./36-neutral.jpg": 64628,
	"./36-sad.jpg": 73781,
	"./37-afraid.jpg": 12203,
	"./37-angry.jpg": 80983,
	"./37-happy.jpg": 88334,
	"./37-neutral.jpg": 17533,
	"./37-sad.jpg": 14544,
	"./38-afraid.jpg": 21030,
	"./38-angry.jpg": 9372,
	"./38-happy.jpg": 21237,
	"./38-neutral.jpg": 87478,
	"./38-sad.jpg": 68411,
	"./39-afraid.jpg": 72033,
	"./39-angry.jpg": 47461,
	"./39-happy.jpg": 52584,
	"./39-neutral.jpg": 48119,
	"./39-sad.jpg": 60366,
	"./4-afraid.jpg": 45037,
	"./4-angry.jpg": 98761,
	"./4-happy.jpg": 44540,
	"./4-neutral.jpg": 44963,
	"./4-sad.jpg": 95306,
	"./40-afraid.jpg": 44353,
	"./40-angry.jpg": 63589,
	"./40-happy.jpg": 2024,
	"./40-neutral.jpg": 45143,
	"./40-sad.jpg": 80334,
	"./41-afraid.jpg": 67430,
	"./41-angry.jpg": 79836,
	"./41-happy.jpg": 7765,
	"./41-neutral.jpg": 16406,
	"./41-sad.jpg": 45851,
	"./42-afraid.jpg": 57319,
	"./42-angry.jpg": 75595,
	"./42-happy.jpg": 86082,
	"./42-neutral.jpg": 94457,
	"./42-sad.jpg": 26316,
	"./43-afraid.jpg": 88164,
	"./43-angry.jpg": 96578,
	"./43-happy.jpg": 14071,
	"./43-neutral.jpg": 56848,
	"./43-sad.jpg": 17841,
	"./44-afraid.jpg": 31885,
	"./44-angry.jpg": 83561,
	"./44-happy.jpg": 97148,
	"./44-neutral.jpg": 88163,
	"./44-sad.jpg": 97418,
	"./45-afraid.jpg": 86354,
	"./45-angry.jpg": 81584,
	"./45-happy.jpg": 47481,
	"./45-neutral.jpg": 12322,
	"./45-sad.jpg": 12215,
	"./46-afraid.jpg": 64483,
	"./46-angry.jpg": 96271,
	"./46-happy.jpg": 51558,
	"./46-neutral.jpg": 78389,
	"./46-sad.jpg": 76712,
	"./47-afraid.jpg": 83840,
	"./47-angry.jpg": 49142,
	"./47-happy.jpg": 85611,
	"./47-neutral.jpg": 18156,
	"./47-sad.jpg": 58925,
	"./48-afraid.jpg": 28905,
	"./48-angry.jpg": 39341,
	"./48-happy.jpg": 30000,
	"./48-neutral.jpg": 14623,
	"./48-sad.jpg": 21814,
	"./49-afraid.jpg": 19406,
	"./49-angry.jpg": 74692,
	"./49-happy.jpg": 20189,
	"./49-neutral.jpg": 30270,
	"./49-sad.jpg": 17827,
	"./5-afraid.jpg": 15538,
	"./5-angry.jpg": 91184,
	"./5-happy.jpg": 8953,
	"./5-neutral.jpg": 10850,
	"./5-sad.jpg": 12087,
	"./50-afraid.jpg": 32968,
	"./50-angry.jpg": 5470,
	"./50-happy.jpg": 70835,
	"./50-neutral.jpg": 99604,
	"./50-sad.jpg": 60341,
	"./51-afraid.jpg": 16715,
	"./51-angry.jpg": 3031,
	"./51-happy.jpg": 95566,
	"./51-neutral.jpg": 65949,
	"./51-sad.jpg": 67312,
	"./52-afraid.jpg": 69146,
	"./52-angry.jpg": 85496,
	"./52-happy.jpg": 65121,
	"./52-neutral.jpg": 99114,
	"./52-sad.jpg": 51743,
	"./53-afraid.jpg": 23381,
	"./53-angry.jpg": 74673,
	"./53-happy.jpg": 37892,
	"./53-neutral.jpg": 89483,
	"./53-sad.jpg": 3410,
	"./54-afraid.jpg": 85324,
	"./54-angry.jpg": 73290,
	"./54-happy.jpg": 22815,
	"./54-neutral.jpg": 54456,
	"./54-sad.jpg": 34105,
	"./55-afraid.jpg": 97839,
	"./55-angry.jpg": 34899,
	"./55-happy.jpg": 51274,
	"./55-neutral.jpg": 23425,
	"./55-sad.jpg": 43828,
	"./56-afraid.jpg": 13390,
	"./56-angry.jpg": 41828,
	"./56-happy.jpg": 96125,
	"./56-neutral.jpg": 59870,
	"./56-sad.jpg": 47555,
	"./57-afraid.jpg": 88201,
	"./57-angry.jpg": 29229,
	"./57-happy.jpg": 85968,
	"./57-neutral.jpg": 50911,
	"./57-sad.jpg": 39190,
	"./58-afraid.jpg": 19936,
	"./58-angry.jpg": 77942,
	"./58-happy.jpg": 1355,
	"./58-neutral.jpg": 94476,
	"./58-sad.jpg": 7117,
	"./59-afraid.jpg": 21571,
	"./59-angry.jpg": 54927,
	"./59-happy.jpg": 56294,
	"./59-neutral.jpg": 91317,
	"./59-sad.jpg": 36808,
	"./6-afraid.jpg": 83555,
	"./6-angry.jpg": 19343,
	"./6-happy.jpg": 86534,
	"./6-neutral.jpg": 46709,
	"./6-sad.jpg": 86408,
	"./60-afraid.jpg": 87747,
	"./60-angry.jpg": 11919,
	"./60-happy.jpg": 32454,
	"./60-neutral.jpg": 66933,
	"./60-sad.jpg": 14248,
	"./61-afraid.jpg": 55488,
	"./61-angry.jpg": 71478,
	"./61-happy.jpg": 56363,
	"./61-neutral.jpg": 39244,
	"./61-sad.jpg": 23181,
	"./62-afraid.jpg": 1165,
	"./62-angry.jpg": 52137,
	"./62-happy.jpg": 96956,
	"./62-neutral.jpg": 2307,
	"./62-sad.jpg": 56778,
	"./63-afraid.jpg": 53298,
	"./63-angry.jpg": 90096,
	"./63-happy.jpg": 67193,
	"./63-neutral.jpg": 87522,
	"./63-sad.jpg": 2775,
	"./64-afraid.jpg": 45767,
	"./64-angry.jpg": 90475,
	"./64-happy.jpg": 60098,
	"./64-neutral.jpg": 33913,
	"./64-sad.jpg": 57708,
	"./65-afraid.jpg": 85284,
	"./65-angry.jpg": 17378,
	"./65-happy.jpg": 96983,
	"./65-neutral.jpg": 58416,
	"./65-sad.jpg": 87505,
	"./66-afraid.jpg": 90721,
	"./66-angry.jpg": 15173,
	"./66-happy.jpg": 54216,
	"./66-neutral.jpg": 60663,
	"./66-sad.jpg": 51502,
	"./67-afraid.jpg": 34118,
	"./67-angry.jpg": 80636,
	"./67-happy.jpg": 92501,
	"./67-neutral.jpg": 7446,
	"./67-sad.jpg": 10523,
	"./68-afraid.jpg": 79915,
	"./68-angry.jpg": 56919,
	"./68-happy.jpg": 54126,
	"./68-neutral.jpg": 65597,
	"./68-sad.jpg": 176,
	"./69-afraid.jpg": 93352,
	"./69-angry.jpg": 59678,
	"./69-happy.jpg": 40595,
	"./69-neutral.jpg": 13332,
	"./69-sad.jpg": 75157,
	"./7-afraid.jpg": 76192,
	"./7-angry.jpg": 46134,
	"./7-happy.jpg": 83627,
	"./7-neutral.jpg": 90988,
	"./7-sad.jpg": 16141,
	"./70-afraid.jpg": 48482,
	"./70-angry.jpg": 15168,
	"./70-happy.jpg": 77225,
	"./70-neutral.jpg": 76434,
	"./70-sad.jpg": 24711,
	"./71-afraid.jpg": 87389,
	"./71-angry.jpg": 75577,
	"./71-happy.jpg": 87660,
	"./71-neutral.jpg": 755,
	"./71-sad.jpg": 35994,
	"./72-afraid.jpg": 60176,
	"./72-angry.jpg": 1222,
	"./72-happy.jpg": 18043,
	"./72-neutral.jpg": 11484,
	"./72-sad.jpg": 44925,
	"./73-afraid.jpg": 67859,
	"./73-angry.jpg": 9407,
	"./73-happy.jpg": 47286,
	"./73-neutral.jpg": 4261,
	"./73-sad.jpg": 22360,
	"./74-afraid.jpg": 66102,
	"./74-angry.jpg": 20204,
	"./74-happy.jpg": 85029,
	"./74-neutral.jpg": 25766,
	"./74-sad.jpg": 72843,
	"./75-afraid.jpg": 7121,
	"./75-angry.jpg": 95221,
	"./75-happy.jpg": 77112,
	"./75-neutral.jpg": 25767,
	"./75-sad.jpg": 15838,
	"./76-afraid.jpg": 74388,
	"./76-angry.jpg": 47538,
	"./76-happy.jpg": 94855,
	"./76-neutral.jpg": 25984,
	"./76-sad.jpg": 14657,
	"./77-afraid.jpg": 71575,
	"./77-angry.jpg": 95355,
	"./77-happy.jpg": 89810,
	"./77-neutral.jpg": 75177,
	"./77-sad.jpg": 94140,
	"./78-afraid.jpg": 26666,
	"./78-angry.jpg": 73736,
	"./78-happy.jpg": 85777,
	"./78-neutral.jpg": 39962,
	"./78-sad.jpg": 48015,
	"./79-afraid.jpg": 85125,
	"./79-angry.jpg": 88737,
	"./79-happy.jpg": 37684,
	"./79-neutral.jpg": 94587,
	"./79-sad.jpg": 96738,
	"./8-afraid.jpg": 78281,
	"./8-angry.jpg": 58989,
	"./8-happy.jpg": 53296,
	"./8-neutral.jpg": 40191,
	"./8-sad.jpg": 59350,
	"./80-afraid.jpg": 11701,
	"./80-angry.jpg": 48817,
	"./80-happy.jpg": 35492,
	"./80-neutral.jpg": 10667,
	"./80-sad.jpg": 6930,
	"./81-afraid.jpg": 94490,
	"./81-angry.jpg": 91128,
	"./81-happy.jpg": 23841,
	"./81-neutral.jpg": 28234,
	"./81-sad.jpg": 19647,
	"./82-afraid.jpg": 62123,
	"./82-angry.jpg": 59639,
	"./82-happy.jpg": 83342,
	"./82-neutral.jpg": 11997,
	"./82-sad.jpg": 31920,
	"./83-afraid.jpg": 15400,
	"./83-angry.jpg": 59806,
	"./83-happy.jpg": 9523,
	"./83-neutral.jpg": 59092,
	"./83-sad.jpg": 91157,
	"./84-afraid.jpg": 90697,
	"./84-angry.jpg": 32717,
	"./84-happy.jpg": 10672,
	"./84-neutral.jpg": 35679,
	"./84-sad.jpg": 63894,
	"./85-afraid.jpg": 48494,
	"./85-angry.jpg": 89412,
	"./85-happy.jpg": 65757,
	"./85-neutral.jpg": 19614,
	"./85-sad.jpg": 52867,
	"./86-afraid.jpg": 11855,
	"./86-angry.jpg": 83059,
	"./86-happy.jpg": 40477,
	"./86-neutral.jpg": 85409,
	"./86-sad.jpg": 84308,
	"./87-afraid.jpg": 68492,
	"./87-angry.jpg": 66218,
	"./87-happy.jpg": 1951,
	"./87-neutral.jpg": 83896,
	"./87-sad.jpg": 65529,
	"./88-afraid.jpg": 57453,
	"./88-angry.jpg": 72489,
	"./88-happy.jpg": 18268,
	"./88-neutral.jpg": 40451,
	"./88-sad.jpg": 16202,
	"./89-afraid.jpg": 27954,
	"./89-angry.jpg": 48560,
	"./89-happy.jpg": 66329,
	"./89-neutral.jpg": 6338,
	"./89-sad.jpg": 16631,
	"./9-afraid.jpg": 52430,
	"./9-angry.jpg": 15684,
	"./9-happy.jpg": 92029,
	"./9-neutral.jpg": 24126,
	"./9-sad.jpg": 48323,
	"./90-afraid.jpg": 42236,
	"./90-angry.jpg": 7354,
	"./90-happy.jpg": 55087,
	"./90-neutral.jpg": 25096,
	"./90-sad.jpg": 50057,
	"./91-afraid.jpg": 37983,
	"./91-angry.jpg": 80195,
	"./91-happy.jpg": 8954,
	"./91-neutral.jpg": 92113,
	"./91-sad.jpg": 35844,
	"./92-afraid.jpg": 66654,
	"./92-angry.jpg": 99092,
	"./92-happy.jpg": 73581,
	"./92-neutral.jpg": 57454,
	"./92-sad.jpg": 69043,
	"./93-afraid.jpg": 70137,
	"./93-angry.jpg": 12989,
	"./93-happy.jpg": 26560,
	"./93-neutral.jpg": 37967,
	"./93-sad.jpg": 41926,
	"./94-afraid.jpg": 87480,
	"./94-angry.jpg": 68494,
	"./94-happy.jpg": 41155,
	"./94-neutral.jpg": 67940,
	"./94-sad.jpg": 24069,
	"./95-afraid.jpg": 72603,
	"./95-angry.jpg": 17767,
	"./95-happy.jpg": 74622,
	"./95-neutral.jpg": 20269,
	"./95-sad.jpg": 10496,
	"./96-afraid.jpg": 20618,
	"./96-angry.jpg": 74056,
	"./96-happy.jpg": 96721,
	"./96-neutral.jpg": 85562,
	"./96-sad.jpg": 79759,
	"./97-afraid.jpg": 17093,
	"./97-angry.jpg": 8577,
	"./97-happy.jpg": 52052,
	"./97-neutral.jpg": 91611,
	"./97-sad.jpg": 25986,
	"./98-afraid.jpg": 27316,
	"./98-angry.jpg": 78514,
	"./98-happy.jpg": 11527,
	"./98-neutral.jpg": 89952,
	"./98-sad.jpg": 71521,
	"./99-afraid.jpg": 99063,
	"./99-angry.jpg": 23259,
	"./99-happy.jpg": 66130,
	"./99-neutral.jpg": 76969,
	"./99-sad.jpg": 45660
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 79439;